export const numbersForHomeSizeFilter: number[] = [
  0, 30, 40, 50, 60, 70, 80, 90, 100, 120, 140, 160, 180, 200, 220, 250, 300, 350, 400, 450, 500, 600, 700, 800, 900,
  1000,
];
